module.exports = __webpack_public_path__ + "static/media/laptop.6799cbc8.png";